import React, { useState } from 'react';
import { Switch, Box, Text, Tooltip } from '@rsos/components/capstone/base';

const AccessRestrictionToggle = ({ onClick, isOn, disabled }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Box width={288} position="relative">
      <Tooltip
        position="bottom"
        text="Toggling the IP access restriction to off will allow users to log in outside of the agency and/or outside of the specified IP addresses."
        isVisible={isVisible}
        maxWidth={288}
        zIndex={3}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        <Box horizontal flow={6} align="center" justify="flex-end">
          <Text color={isOn ? 'success' : 'secondaryText'} size="normal">
            IP Access Restriction
          </Text>
          <Switch isOn={isOn} disabled={disabled} onClick={onClick} />
        </Box>
      </Tooltip>
    </Box>
  );
};

export default AccessRestrictionToggle;
